let errorEmailSent = false;
let _windowWidth = window.outerWidth;
let resized;

function resizeWidthOnly() {
    let currentWindowWidth = window.outerWidth;
    if (_windowWidth !== currentWindowWidth) {
        _windowWidth = currentWindowWidth;
        return _windowWidth;
    } else {
        return false;
    }
}

function resizedw() {
    if (resizeWidthOnly() !== false) {
        getEgoCSectionBackgroundHeight();
        getPDPMultiColumnTitleHeight();
    }
}

$(window).resize(function () {
    clearTimeout(resized);
    resized = setTimeout(resizedw, 100);
});

function loadingMask(_type) {
    let _loadingMask = $(".loading-mask");
    _type === "show" ? _loadingMask.addClass("active") : _loadingMask.removeClass("active");
}

function getApiPath(shortPath) {
    return new Promise(function (resolve, reject) {
        let apiPath = false;
        $.ajax({
            type: 'POST',
            url: apiURL + "rest/all/V1/chervon/proxy/account-center-status/1"//this defaults to the EGO US Store View
        })
            .done(function (dataAjax) {
                dataAjax = JSON.parse(dataAjax);

                if (dataAjax["accountCenterStatus"] === "1") {
                    alert(dataAjax["accountCenterDisabledText"]);
                    logout();
                } else if (dataAjax["preventRegistrationAllowLoginToggle"] === "1" && pathname.indexOf("/pages/register") !== -1) {  //translate
                    alert(dataAjax["preventRegistrationAllowLoginCopy"]);
                    logout();
                } else {
                    // if (window.location.hostname === "www.egocommercial.com" || window.location.hostname === "egocommercial.com" || window.location.hostname === "egocommercial.myshopify.com") {
                    //     apiPath = "https://chervon-website-api.herokuapp.com/WebSiteApi/v2.0/" + shortPath;
                    // } else {
                    //     console.log('Using heroku sandbox URL for relative path = ' + shortPath);
                    //     apiPath = "https://chervon-website-api-dev.herokuapp.com/WebSiteApi/v2.0/" + shortPath;
                    // }

                    // if (window.location.hostname === "integration-5ojmyuq-7eckfds2hysmw.us-3.magentosite.cloud") {
                    //     apiPath = "https://chervon-website-api-dev.herokuapp.com/WebSiteApi/v2.0/" + shortPath;
                    // }

                    // if (window.location.hostname === "local.egopowerplus.com") {
                    // apiPath = "http://localhost:8080/WebSiteApi/v2.0/" + shortPath;
                    // }

                    apiPath = "https://chervon-website-api.herokuapp.com/WebSiteApi/v2.0/" + shortPath;
                    resolve(apiPath);
                }
            })
            .fail(function (error) {
                errorNotify('Ego Commercial: Error Loading Account Center Status', error);
                alert(window.theme.custom.global.error.generic_error);
                logout();
            });
    });
}

function errorNotify(error, errData = null) {
    if (errorEmailSent === false) {
        errorEmailSent = true;

        let data = JSON.parse(localStorage.getItem('currentUser'));
        let locationInfo = JSON.parse(localStorage.getItem('locationInfo'));
        let ipAddress = locationInfo && locationInfo.IpAddress ? locationInfo.IpAddress : "N/A";
        let date = new Date();

        let dataPayload = errData ? errData : {};
        if (typeof dataPayload !== "object") {
            dataPayload = { 'data': dataPayload };
        }
        dataPayload['ipAddress'] = ipAddress;

        let postData = JSON.stringify({
            'email': data && data.email ? data.email : "",
            'errorMsg': typeof error == "object" ? JSON.stringify(error) : error,
            'timeStamp': date.getTime(),
            'userAgent': navigator.userAgent,
            'location': window.location.href,
            'data': dataPayload
        });

        const xhr = new XMLHttpRequest();
        xhr.open("POST", "https://chervon-logging.rain-staging.com/index.php");
        xhr.setRequestHeader("Content-Type", "application/json");

        xhr.onload = () => {
            if (xhr.readyState === 4 && xhr.status === 201) {
                console.log(JSON.parse(xhr.responseText));
            } else {
                console.log(`Error: ${xhr.status}`);
            }
        }

        xhr.send(postData);
    }
}

function titleCase(str) {
    str = str.toLowerCase().split(' ');
    for (var i = 0; i < str.length; i++) {
        str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
    }
    return str.join(' ').trim();
}

function getObj(attr, id) {
    let result = null;

    let findData = function (elem) {
        if (elem[attr] === id) {
            result = elem;
            return elem[attr] === id;
        }
    }

    $.each(EGO_REGISTER_DATA, function (i, obj) {
        if (obj.products.length > 0) {
            obj.products.find(findData);
            obj.products.forEach(function (product) {
                if (product.crosssell && product.crosssell.length > 0) {
                    product.crosssell.find(findData);

                    // product.crosssell.forEach(function (product) {
                    //     if (product.crosssellBareTool && product.crosssellBareTool.length > 0) {
                    //         product.crosssellBareTool.find(findData);
                    //     }
                    // });
                }
            });
        }

        if (obj.subcategories && obj.subcategories.length > 0) {
            obj.subcategories.forEach(function (sobj) {
                sobj.products.find(findData);
                sobj.products.forEach(function (tobj) {
                    tobj.crosssell.find(findData);
                });
            });

            if (obj.subcategories.crosssell && obj.subcategories.crosssell.length > 0) {
                obj.subcategories.crosssell.find(findData);
            }
        }
    });

    if (!result && id) {
        if (pathname.indexOf("/pages/register") >= 0) {
            console.log(`%c ERROR 404: Couldn't find the product with ${attr}: ${id} `, 'background: red; color: white;');
            errorNotify(`ERROR 404: Couldn't find the product with ${attr}: ${id}`);
            alert(window.theme.custom.global.error.generic_error);
        }
    }

    return result;
}

function getUtmParameter(_parameters) {
    let _parameter = _parameters.split(",");

    $(_parameter).each(function (i, obj) {
        let _obj = obj.trim();

        let utmParameter = sessionStorage.getItem(_obj);

        if (!utmParameter) {
            utmParameter = getUrlParameter(_obj);
        }

        if (utmParameter) {
            sessionStorage.setItem(_obj, utmParameter);

            gtmParams = gtmParams ? gtmParams + " data-csi_" + _obj + "=" + utmParameter + "" : "data-csi_" + _obj + "=" + utmParameter + "";
        }
    });
}

function showUploadPicker() {
    const client = filestack.init('AfwFq9knNSzC3v5VbD5wvz');
    const options = {
        accept: ["image/*", "text/*", ".pdf"],
        fromSources: ['local_file_system', 'webcam', 'url', 'box', 'googledrive', 'clouddrive', 'onedrive'],
        onFileUploadFinished(file) {
            $("#receipt-file, #service-file").val(file.url);
            $("#receipt-file-name, #service-file-name").text(file.filename);
        }
    };
    client.picker(options).open();
}

function scrollToGlobal(trigger, block) {
    $(trigger).on('click', function (e) {
        e.preventDefault();

        let headerHeight = $('header').outerHeight();

        $('html,body').scrollTop($(block).offset().top - headerHeight + 5);
    });
}

$(function () {
// start custom jquery validation
// email validation
// 0-9, a-z or A-Z
// @a-z or @A-Z
// .a-z or .A-Z
    $.validator.addMethod("customemailvalidation", function (value, element) {
        if (value.indexOf("mailosaur.net") !== -1) {
            return true;
        } else {
            return this.optional(element) || /[a-zA-Z0-9]+@[a-zA-Z0-9-]+\.[a-zA-Z]|\.[a-zA-Z]+/.test(value);
        }
    }, window.theme.custom.global.error.email);

    $.validator.addMethod("preventonlywhitespace", function (value, element) {
        return (value.trim() !== "")
    }, window.theme.custom.global.error.required);

    $.validator.addMethod("lettersOnly", function (value, element) {
        return this.optional(element) || /^[a-zA-Z- ]*$/.test(value);
    }, window.theme.custom.global.error.lettersOnly);

    $.validator.addMethod("noPostOfficeBox", function (value, element) {
        return !(this.optional(element) || /\b(?:p\.?\s*o\.?|post\s+office)(\s+)?(?:box|[0-9]*)?\b/.test(value));
    }, window.theme.custom.global.error.noPostOfficeBox);

    $.validator.addMethod("alphanumeric", function (value, element) {
        return this.optional(element) || /^\w+$/i.test(value);
    }, window.theme.custom.global.error.alphanumeric);

    $.validator.addMethod('passwordValidationLetterNumberSpecialCharacter', function (value, element, param) {
        return value.match(/^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[~`!@#$%^&*()\-_+='{}[\]|\;:"<>,.\/\\?])[a-zA-Z0-9~`!@#$%^&*()\-_+='{}[\]|\;:"<>,.\/\\?]+$/i);
    }, window.theme.custom.global.error.passwordValidationLetterNumberSpecialCharacter);

    $.validator.addMethod('passwordValidationPreventNameMatch', function (value, element, param) {
        let _thisForm = $(element).closest("form");
        value = value.toLowerCase();
        let _fName = _thisForm.find("#create_first_name").val().toLowerCase();
        let _lName = _thisForm.find("#create_last_name").val().toLowerCase();
        let _email = _thisForm.find("#create_email").val().toLowerCase();
        _email = _email.substring(0, _email.indexOf('@'));

        //1. checks that all 3 fields have values fname, lname & email
        //2. checks that all 3 fields do not have the same string and where against the password
        return !((_fName.length > 0 && _lName.length > 0 && _email.length > 0) && (value.includes(_fName) || value.includes(_lName) || value.includes(_email)));

    }, window.theme.custom.global.error.passwordValidationPreventNameMatch);

    $.validator.addMethod('placeOfPurchaseValidation', function (value) {
        if ($(".js-purchase-place").val() === 'Other') {
            return (value.trim() !== "");
        } else {
            return true;
        }
    }, window.theme.custom.global.error.place_of_purchase_validation);

    $.validator.addMethod("preventHTML", function (value, element) {
        return this.optional(element) || /^[^<>:&]*$/.test(value);
    }, window.theme.custom.global.error.alphanumeric);

    $.validator.addMethod('dateValidation', function (value) {
        var match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(value);
        if (!match) {
            return false;
        }
        var month = parseInt(match[1], 10) - 1; // months are 0-11, not 1-12
        var day = parseInt(match[2], 10);
        var year = parseInt(match[3], 10);
        var date = new Date(year, month, day);
        let todayDate = new Date();
        if (date >= todayDate) {
            return false;
        }

        return date.getDate() == day && date.getMonth() == month && date.getFullYear() == year;
    }, window.theme.custom.global.error.date_validation);
});